<template>
  <select-create
    :model="model"
    :columns="columns"
    createApi="CompanyDetails/Create"
    :createModel="formModel"
    :data="dataSource.records"
    :isLoading="dataSource.isLoading"
    :fields="fields"
    :disabled="isDisabled"
    :getLabel="getLabel"
    v-bind="$attrs"
    v-on="$listeners"
    @validate="handlerValidate"
    @on-created="handlerCreated"
  >
    <template v-slot:form="{ change, data }">
      <create-form ref="form" :companyID="companyID" :model="formModel" :data="data" @change="change"></create-form>
    </template>
  </select-create>
</template>

<script>
import { api } from '@/services/api'
const L10n = window.app.L10n

export default {
  name: 'SelectCompanyDetail',
  components: {
    'select-create': () => import(/* webpackChunkName: 'Shared' */ '@/components/Form/UI/Selects/SelectCreate/Index'),
    'create-form': () => import(/* webpackChunkName: 'Shared' */ './Form.vue')
  },
  props: {
    withAutoSelect: { type: Boolean, default: false },
    companyID: { required: true },
    model: { required: true },
    fields: { type: Object, default: () => ({ title: 'country', id: 'id' }) },
    disabled: { type: Boolean, default: false },
    columns: {
      type: Array,
      default: () => (
        [
          { title: L10n('country'), value: 'country' },
          { title: L10n('city'), value: 'city' },
          { title: L10n('street'), value: 'street' },
          { title: L10n('state'), value: 'state' },
          { title: L10n('address-type-division'), value: 'addressTypeDivisionTitle' }
        ]
      )
    },
    getLabel: {
      type: Function,
      default (item) {
        return item[this.fields.title]
      }
    }
  },
  watch: {
    companyID: {
      immediate: true,
      handler: '_changeCompanyID'
    }
  },
  data () {
    return {
      delayUpdateValue: 600,
      dataSource: {
        map: [],
        records: [],
        isLoading: false
      }
    }
  },
  computed: {
    isDisabled () {
      return this.disabled || !this.companyID
    }
  },
  methods: {
    formModel () {
      return {
        companyID: this.companyID,
        companyTypeID: null,
        street: '',
        city: '',
        remark: '',
        country: '',
        zipCode: '',
        fax: '',
        state: '',
        phone: '',
        addressTypeDivisionID: null,
        email: '',
        scoreID: null,
        vatNumber: '',
        baxEmployeeID: this.$store.getters.get('currentUser').employeeID
      }
    },
    _changeCompanyID (companyID) {
      this.updateDataSource()
        .then((result) => {
          if (this.withAutoSelect && !this.model) {
            this._autoSelect()
          }
          return result
        })
    },
    async updateDataSource () {
      let promise = this.companyID
        ? this._requestGetDataSource()
        : Promise.resolve({ value: [] })
      return promise
        .then((data) => {
          this.dataSource.records = data.value
          this.dataSource.map = data.value.reduce((result, item) => {
            result[item.id] = item
            return result
          }, {})
        })
    },
    _requestGetDataSource () {
      this.dataSource.isLoading = true
      return api
        .get(`CompanyDetails/GetAllDynamic`, { params: this._createParams() })
        .then((response) => {
          this.dataSource.isLoading = false
          return response.data
        })
    },
    _createParams () {
      return {
        'select': 'id,country,city,street,state,division.title as addressTypeDivisionTitle',
        'filter': `companyID == ${this.companyID}`
      }
    },
    _autoSelect () {
      if (this.dataSource.records.length === 1) {
        const data = this.dataSource.records[0]
        const value = data[this.fields.id]
        const title = (data && this.getLabel(data)) || null
        this.$emit('update:model', value)
        this.$emit('on-change', value, data, title)
      }
    },
    handlerCreated () {
      this.updateDataSource()
    },
    handlerValidate (callback) {
      this.$refs.form.validate()
        .then(() => {
          callback()
        })
        .catch(() => {
          callback(new Error('invalid part form'))
        })
    }
  }
}
</script>
